@if (isArrowHide) {
<button
  [ngClass]="ngClass"
  type="button"
  [disabled]="isButtonDisabled"
  [ngStyle]="{
    cursor: isButtonDisabled ? 'default' : 'pointer',
    backgroundColor: isFilled ? bgColor : 'transparent',
    borderColor: !isFilled && isFocusEnabled ? borderColor : '',
    color: textColor,
    width: buttonWidth,
    height: buttonHeight,
    padding: buttonPadding,
    fontSize: fontSize
  }"
  (click)="onHandleClick(); onClickButtonEvent($event)"
>
  {{ name }}
</button>
} @else { @if (!isIconOnlyButton) {
<button
  [ngClass]="ngClass"
  type="button"
  [disabled]="isButtonDisabled"
  [ngStyle]="{
    cursor: isButtonDisabled ? 'default' : 'pointer',
    backgroundColor: isFilled ? bgColor : 'transparent',
    borderColor: !isFilled && isFocusEnabled ? borderColor : '',
    color: textColor,
    width: buttonWidth,
    height: buttonHeight,
    fontSize: fontSize
  }"
  (click)="onHandleClick(); onClickButtonEvent($event)"
>
  @if (isMatIcon) {
  <mat-icon
    [ngClass]="ngIconClass"
    class="button-icon"
    [ngStyle]="{ color: iconColor }"
    >{{ icon }}</mat-icon
  >
  } @if (!isMatIcon) {
  <i
    [class]="icon"
    [ngClass]="ngIconClass"
    class="button-icon"
    [ngStyle]="{ color: iconColor }"
  >
  </i>
  }
  {{ name }}
</button>
}
<!-- icon only button without badge -->
@if (isIconOnlyButton && !isBadgeDisplay) {
<button
  class="icon-only-button"
  [ngClass]="ngClass"
  type="button"
  [disabled]="isButtonDisabled"
  [ngStyle]="{
    cursor: isButtonDisabled ? 'default' : 'pointer',
    backgroundColor: isFilled ? bgColor : 'transparent',
    borderColor: !isFilled && isFocusEnabled ? borderColor : '',
    color: textColor,
    padding: buttonPadding,
    width: buttonWidth,
    height: buttonHeight,
    fontSize: fontSize
  }"
  (click)="onHandleClick(); onClickButtonEvent($event)"
>
  @if (isMatIcon) {
  <mat-icon
    class="button-icon"
    [ngClass]="ngIconClass"
    [ngStyle]="{ color: iconColor }"
    >{{ icon }}</mat-icon
  >
  } @if (!isMatIcon) {
  <i
    [class]="icon"
    class="button-icon"
    [ngClass]="ngIconClass"
    [ngStyle]="{ color: iconColor }"
  >
  </i>
  }
</button>
}
<!-- icon only button with badge -->
@if (isIconOnlyButton && isBadgeDisplay) {
<button
  class="icon-only-button"
  [ngClass]="ngClass"
  type="button"
  [disabled]="isButtonDisabled"
  [ngStyle]="{
    cursor: isButtonDisabled ? 'default' : 'pointer',
    backgroundColor: isFilled ? bgColor : 'transparent',
    borderColor: !isFilled && isFocusEnabled ? borderColor : '',
    color: textColor,
    padding: buttonPadding,
    width: buttonWidth,
    height: buttonHeight,
    fontSize: fontSize
  }"
  (click)="onHandleClick(); onClickButtonEvent($event)"
>
  @if (isMatIcon) {
  <mat-icon
    class="button-icon"
    [ngClass]="ngIconClass"
    [ngStyle]="{ color: iconColor }"
    matBadge="{{ badgeValue }}"
    matBadgeColor="warn"
    >{{ icon }}</mat-icon
  >
  } @if (!isMatIcon) {
  <i
    [class]="icon"
    class="button-icon"
    [ngClass]="ngIconClass"
    [ngStyle]="{ color: iconColor }"
  >
  </i>
  }
</button>
} }
